import React, { useState, useEffect } from "react";
import CustomerProgress from "../../../components/progressBar/CustomerProgress";
import { X } from "lucide-react";

const FifthModal = ({
  id_R,
  closeAddInfoModal,
  addInfoModalOpen,
  kraPin,
  setKraPin,
  monthlyIncome,
  setMonthlyIncome,
  jobTitle,
  setJobTitle,
  employment_type,
  setEmploymentType,
  openNextOfKin,
  openAddressInfoModal,
}) => {
const [formattedIncome, setFormattedIncome] = useState("");

  const handleChange = (e) => {
    let value = e.target.value;

    // Remove anything that's not a digit
    const rawValue = value?.replace(/[^0-9]/g, "");

    // Format with commas
    const formattedValue = new Intl.NumberFormat().format(rawValue);

    setMonthlyIncome(rawValue);       // clean value (e.g., 10000)
    setFormattedIncome(formattedValue); // display value (e.g., 10,000)
  };


  const handleBackButtonClick = () => {
    // Close the current modal
    closeAddInfoModal();

    // Open the next modal
    openAddressInfoModal();
  };
  const handleNextButtonClick = () => {
    // Close the current modal
    closeAddInfoModal();

    // Open the next modal
    openNextOfKin();
  };

  const [isInputsFilled, setIsInputsFilled] = useState(false);

  useEffect(() => {
    const areInputsFilled = !!(kraPin && monthlyIncome);
    setIsInputsFilled(areInputsFilled);
  }, [kraPin, monthlyIncome]);
  return (
    <>
      <div
        onClick={closeAddInfoModal}
        id={id_R}
        className={`${
          addInfoModalOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="relative rounded-[10px] flex h-[550px] w-[1080px] bg-white shadow"
        >
          <div
            onClick={closeAddInfoModal}
            className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
          >
            <X color="#ffffff" />
          </div>
          <div className="flex w-full mx-auto">
            <div className=" w-[28%] rounded-[10px] bg-[#F5F6F7]">
              <div className="pt-4 px-2 rounded-t">
                <p className="text-[20px] font-bold text-[#000] ml-5">
                  Add Member
                </p>
              </div>
              <div className="mt-[32px] px-6">
                <CustomerProgress step={5} />
              </div>
            </div>
            <div className="w-[72%] mx-[10px] flex flex-col justify-between">
              <div className="h-[85%] w-[95%]">
                <div className="mt-5 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Additional information
                  </p>
                  <div className="text-[#000] my-5 text-[15px] font-normal">
                    <p className="w-[100%]">
                      Enter Member’s income details as well as verify Member’s
                      KRA PIN. KRA PIN will also verify Member’s personal
                      details.
                    </p>
                  </div>
                </div>

                <div className="flex w-full justify-between">
                  <div className="flex w-[49%] flex-col justify-center">
                    <label
                      htmlFor="employment_typeInput"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      Employment type
                    </label>
                    <select
                      name="county"
                      id="county"
                      value={employment_type}
                      onChange={(e) => setEmploymentType(e.target.value)}
                      className="w-[100%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    >
                      <option value="Employed">Employed</option>
                      <option value="SelfEmployed">Self Employed</option>
                    </select>
                  </div>
                  <div className="flex w-[49%] flex-col justify-center">
                    <label
                      htmlFor="jobTitleInput"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      Job Title
                    </label>
                    <input
                      type="text"
                      id="jobTitleInput"
                      name="jobTitle"
                      placeholder="Enter your job title"
                      value={jobTitle}
                      onChange={(e) => setJobTitle(e.target.value)}
                      className="w-[100%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                </div>

                <div className="flex w-[49%] flex-col mt-10 justify-center">
                  <label
                    htmlFor="incomeInput"
                    className="mb-1 text-md font-normal text-[#000]"
                  >
                    Monthly Income
                  </label>
                  <div className="flex items-center w-[100%] h-10 rounded-[4px] border border-[1px] border-[#000]">
                    <div className="flex items-center justify-center text-[#000] w-[20%] h-10 font-normal border-r border-t border-b  border-[#000]">
                      KES
                    </div>
                    <input
                      type="text"
                      id="incomeInput"
                      name="monthlyIncome"
                      placeholder="Enter your monthly income"
                      value={formattedIncome}
                      // onChange={(e) => setMonthlyIncome(e.target.value)}
                      onChange={handleChange}
                      className="w-[100%] h-9 px-4"
                    />
                  </div>
                </div>

                <div className="flex flex-col justify-center mt-10">
                  <div className="flex w-[49%] flex-col justify-center">
                    <label
                      htmlFor="kraPinInput"
                      className="mb-1 text-md font-normal text-[#000]"
                    >
                      KRA PIN
                    </label>
                    <div className="flex gap-4">
                      <input
                        type="text"
                        id="kraPinInput"
                        name="kraPin"
                        placeholder="Enter your KRA PIN"
                        value={kraPin}
                        onChange={(e) => setKraPin(e.target.value)}
                        className="w-[100%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[95%] h-[15%] flex items-center justify-between">
                <div className="flex items-center justify-between w-[15vw]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id_R}
                    type="button"
                    className="text-[#000] bg-[#7FB8EB] hover:bg-[#7FB8EB] focus:outline-none font-normal rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Back
                  </button>
                </div>
                <button
                  onClick={handleNextButtonClick}
                  type="button"
                  className={`text-white ${
                    isInputsFilled
                      ? "bg-[#074073] hover:bg-[#074073] focus:outline-none"
                      : "bg-[#D9D9D9] pointer-events-none"
                  } block font-normal rounded-[5px] text-sm px-8 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FifthModal;
